import { IPhotoUpload, IUploadUrlRequest, PhotoData } from '@ui-app/models/common.models';
import { Observable } from 'rxjs';

export abstract class PhotoUploadService implements IPhotoUpload {
    protected readonly maxFileSize = 100 * 1024; // 100Kb
    abstract uploadPhoto(request: IUploadUrlRequest, uploadUrl: string, dataUrl: string): Observable<PhotoData>;

    base64ToArrayBuffer(base64: string): { arrayBuffer: ArrayBuffer | string; length: number } {
        const binaryString = window.atob(base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
        const length = binaryString.length;
        const bytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return {
            arrayBuffer: bytes.buffer,
            length
        };
    }

    recursiveCompress(canvas: HTMLCanvasElement, dataUrl: string, imageQuality: number): string {
        const { length } = this.base64ToArrayBuffer(dataUrl);

        while (length >= this.maxFileSize) {
            imageQuality = +(imageQuality * 0.9).toFixed(2);
            dataUrl = canvas.toDataURL('image/jpeg', imageQuality);
            return this.recursiveCompress(canvas, dataUrl, imageQuality);
        }

        console.log('ACTUAL_IMAGE_QUALITY ', imageQuality);
        return dataUrl;
    }
}
